import React from "react";
import { convertToDateOnly } from "../../../utils/EleghoUtils";
import { FiCalendar, FiClock, FiUser, FiHash, FiEye } from "react-icons/fi";

export default function FacilityRequestCard({ data }) {
  const getStatusColor = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "text-eleghoGreen";
      case "pending":
        return "text-yellow-500";
      case "rejected":
        return "text-red-500";
      default:
        return "text-gray-600";
    }
  };

  const getStatusBg = (status) => {
    switch (status?.toLowerCase()) {
      case "approved":
        return "bg-eleghoGreen/10";
      case "pending":
        return "bg-yellow-50";
      case "rejected":
        return "bg-red-50";
      default:
        return "bg-gray-50";
    }
  };

  return (
    <div className="grid grid-cols-6 py-3 px-4 items-center hover:bg-gray-50 transition-colors">
      <div className="flex items-center gap-2">
        <div className="p-1.5 bg-gray-50 rounded-lg">
          <FiUser className="w-4 h-4 text-gray-600" />
        </div>
        <div className="font-medium text-gray-800">
          {data.createdName || "Not Set"}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="p-1.5 bg-gray-50 rounded-lg">
          <FiHash className="w-4 h-4 text-gray-600" />
        </div>
        <div className="text-gray-700">{data.id}</div>
      </div>

      <div className="flex items-center gap-2">
        <div className="p-1.5 bg-gray-50 rounded-lg">
          <FiCalendar className="w-4 h-4 text-gray-600" />
        </div>
        <div className="text-gray-700 capitalize">
          {convertToDateOnly(data.date)}
        </div>
      </div>

      <div className="flex items-center gap-2">
        <div className="p-1.5 bg-gray-50 rounded-lg">
          <FiClock className="w-4 h-4 text-gray-600" />
        </div>
        <div className="text-gray-700">
          {data.startTime} to {data.endTime}
        </div>
      </div>

      <div>
        <span
          className={`capitalize px-2 py-1 rounded-full text-xs font-medium ${getStatusBg(
            data.status
          )} ${getStatusColor(data.status)}`}
        >
          {data.status}
        </span>
      </div>

      <div>
        <button className="px-3 py-1 bg-eleghoBlue/10 text-eleghoBlue rounded-md text-xs hover:bg-eleghoBlue/20 transition-colors flex items-center gap-1">
          <FiEye className="w-3 h-3" />
          View Details
        </button>
      </div>
    </div>
  );
}
